import { getHistoryData } from "../../data/ramotswe";
import { getCurrentObservatoryName } from "../../utils";
import {
  DashboardTimeLineGraph,
  HistogramGraph,
} from "../../graphs/base_graphs";
import { DateTime } from "../../imports";

export default async function initializeCloudiness() {
  // define how the data is fetched
  async function getData() {
    const endDateTime = DateTime.now().setZone("UTC");
    const startDateTime = endDateTime.minus({ months: 1 });
    return await getHistoryData(
      getCurrentObservatoryName(),
      "binnedtelemetrydata",
      startDateTime,
      endDateTime,
      {
        model: "CloudWatcher",
        column_names: ["clarity"],
        cloudwatcher_return_type: "labels",
        timestep_size: 86400,
      }
    );
  }

  // set up the initial data and axes
  const initialData = await getData();

  // bin the data
  const cloudinessGraph = new HistogramGraph(
    "#cloudiness-graph",
    "clarity_label",
    "Sky Visibility",
    "Last 30 Days",
    ["clear", "cloudy", "overcast"]
  );

  // set the graph parameters for consistency in initialization & refresh
  function makeHistogramParams(allGraphData, hideSVG) {
    return [
      allGraphData, // all data is in one array
      "clarity_label",
      { transition: true, hideSVG: hideSVG },
    ];
  }

  const histaxesKey = cloudinessGraph.plotHistogram(
    ...makeHistogramParams(initialData, true)
  );

  cloudinessGraph.showLoading();

  // define the refresh function
  async function refresh() {
    cloudinessGraph.showLoading();
    const newData = await getData();

    cloudinessGraph.plotHistogram(...makeHistogramParams(newData, false));
  }

  return refresh;
}
